import { render, staticRenderFns } from "./confirm-delete-quiz.vue?vue&type=template&id=630820be&scoped=true"
import script from "./confirm-delete-quiz.vue?vue&type=script&lang=js"
export * from "./confirm-delete-quiz.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-quiz.vue?vue&type=style&index=0&id=630820be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630820be",
  null
  
)

export default component.exports